import React, { Component } from 'react';
import _get from 'lodash/get';
import Slider from 'react-slick';
import { makeValidUrl, getNavTag } from './utils';

import MenuSublistSec from './MenuSublistSec';
import firstLetterCapital from '../../../../refresh/utils/firstLetterCapitalUtils';
import LuxeBrandList from '../Navigation/LuxeBrandList';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

const sortObjectByKeys = brands => {
  return Object.keys(brands)
    .sort()
    .reduce((acc, key) => ((acc[key] = brands[key]), acc), {});
};
class MenuSublistFirst extends Component {
  constructor(props) {
    super(props);
    this.state = { active: false, inactive: false };
  }

  mouseEnter = (event) => {
    this.setState({ active: true });
  };

  mouseExit = (event) => {
    this.setState({ active: false });
  };

  handleMoreRemainingItems = (
    differenceData,
    nextCurrEntity,
    nextCurrentItems,
    nextCurrColumn,
    acc,
    currItem,
    columnDataLength
  ) => {
    if (differenceData >= 0) {
      nextCurrEntity.spaceLeftInCol = differenceData;
      nextCurrEntity.colData = _get(nextCurrEntity, 'colData', []);
      nextCurrEntity.colData.push(nextCurrentItems);
      acc.entities[`${nextCurrColumn}`] = nextCurrEntity;
      acc.results.push(`${nextCurrColumn}`);
      return acc;
    } else {
      let remainingNextItems = { ...currItem };
      let differenceValue = Math.abs(differenceData);
      nextCurrEntity.spaceLeftInCol = 0;
      nextCurrEntity.colData = _get(nextCurrEntity, 'colData', []);
      nextCurrentItems.values = nextCurrentItems.values.slice(0, differenceData);
      nextCurrEntity.colData.push(nextCurrentItems);
      acc.entities[`${nextCurrColumn}`] = nextCurrEntity;
      acc.results.push(`${nextCurrColumn}`);
      remainingNextItems.name = '';
      remainingNextItems.values = remainingNextItems.values.slice(differenceData);
      let remainingNextCurrColumn = nextCurrColumn + 1;
      let remainingCurrEntity = _get(acc, `entities[${remainingNextCurrColumn}]`, {});
      let spaceLeftInCol = _get(remainingCurrEntity, 'spaceLeftInCol', columnDataLength);
      differenceData = spaceLeftInCol - differenceValue;
      return this.handleMoreRemainingItems(
        differenceData,
        remainingCurrEntity,
        remainingNextItems,
        remainingNextCurrColumn,
        acc,
        currItem,
        columnDataLength
      );
    }
  };

  render() {
    const {
      data = {},
      linkClick,
      newDesignLuxe,
      isBrands = false,
      isNewBrandDirectoryDesktop,
      ABFlagObj,
      makeAbFlagUrl,
    } = this.props;
    const { location = {} } = window;
    const { pathname } = location;
    let {
      imageDetails = [],
      imageCaption = '',
      childDetails = [],
      url = '',
      name = '',
      tag
    } = data;
    imageDetails = imageDetails || [];
    childDetails = childDetails || [];

    if (isBrands && newDesignLuxe) {
      let brandsData = {};
      let list = [];
      var Regx = /^[A-Za-z]$/;
      childDetails.map(eachValue => {
        list = [...list, ...JSON.parse(JSON.stringify(eachValue.childDetails))];
      });
      list.sort((a,b) => (a?.name?.toLowerCase() > b?.name?.toLowerCase()) ? 1 : ((b?.name?.toLowerCase() > a?.name?.toLowerCase()) ? -1 : 0))
      list.forEach(c => {
        let listName = c?.name || '';
        let firstChar = listName?.charAt(0);
        if (!Regx.test(firstChar)) {
          firstChar = '#';
        }
        brandsData[firstChar] = [
          ...(brandsData[firstChar] || []),
          { name: firstLetterCapital(listName?.toLowerCase()), link: c.url || c.link }
        ];
      });
      brandsData = sortObjectByKeys(brandsData);
      let result = [];
      Object.keys(brandsData).map(each => {
        result.push({
          hot: false,
          name: each,
          values: brandsData[each]
        });
      });
      childDetails = result;
    }

    let slickSettings = {
      dots: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2500,
      swipe: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      waitForAnimate: false,
      fade: true
    };

    const activeLink = this.state.active ? 'active-text' : 'inactive-text';
    let imageSlider = imageDetails.map((imageDetails, j) => {
      return (
        <li key={j}>
          <div className="image-sec" key={j}>
            <a
              href={makeAbFlagUrl(makeValidUrl(imageDetails.imageLink))}
              onClick={() => {
                linkClick(imageDetails.imageLink, '');
              }}
            >
              <img src={`${replaceWithJioCDN(imageDetails.image)}`} />
            </a>
          </div>
        </li>
      );
    });

    let menuColMap = {};
    if (isBrands && newDesignLuxe) {
      let columnDataLength = window.innerHeight > 700 ? 14 : 11;
      menuColMap = childDetails.reduce(
        (acc, currItem = {}) => {
          let currentItemsNew = [];
          if (currItem && currItem.values && Array.isArray(currItem.values)) {
            currentItemsNew = currItem.values.filter(c_value => {
              // if (!c_value.link) {
              // 	return false;
              // }
              return true;
            });
          }
          let currColumn = _get(acc, `results[${_get(acc, 'results.length', 1) - 1}]`, 0);
          currColumn = parseInt(currColumn);
          let currEntity = _get(acc, `entities[${currColumn}]`, {});
          let spaceLeftInCol = _get(currEntity, 'spaceLeftInCol', columnDataLength);
          let spaceNeeded = _get(currentItemsNew, 'length', 0) + 1;
          if (spaceLeftInCol >= spaceNeeded) {
            currEntity.spaceLeftInCol = spaceLeftInCol - spaceNeeded;
            currEntity.colData = _get(currEntity, 'colData', []);
            currEntity.colData.push(currItem);
            acc.entities[`${currColumn}`] = currEntity;
          } else if (spaceLeftInCol > 1) {
            currEntity.spaceLeftInCol = 0;
            currEntity.colData = _get(currEntity, 'colData', []);
            let updatedData = { ...currItem };
            let nextCurrentItems = { ...currItem };
            nextCurrentItems.name = '';
            const remainingDataLength = spaceLeftInCol - 1;
            updatedData.values = currItem.values.slice(0, remainingDataLength);
            spaceNeeded = currItem.values.length - remainingDataLength;
            nextCurrentItems.values = currItem.values.slice(remainingDataLength);
            currEntity.colData.push(updatedData);
            acc.entities[`${currColumn}`] = currEntity;
            let nextCurrColumn = currColumn + 1;
            let nextCurrEntity = _get(acc, `entities[${nextCurrColumn}]`, {});
            spaceLeftInCol = _get(nextCurrEntity, 'spaceLeftInCol', columnDataLength);
            let differenceData = spaceLeftInCol - spaceNeeded;
            return this.handleMoreRemainingItems(
              differenceData,
              nextCurrEntity,
              nextCurrentItems,
              nextCurrColumn,
              acc,
              currItem,
              columnDataLength
            );
          } else {
            currColumn += 1;
            currEntity = _get(acc, `entities[${currColumn}]`, {});
            spaceLeftInCol = _get(currEntity, 'spaceLeftInCol', columnDataLength);
            spaceNeeded = _get(currentItemsNew, 'length', 0) + 1;
            let differenceData = spaceLeftInCol - spaceNeeded;
            return this.handleMoreRemainingItems(
              differenceData,
              currEntity,
              { ...currItem },
              currColumn,
              acc,
              currItem,
              columnDataLength
            );
          }
          return acc;
        },
        {
          results: ['1'],
          entities: {
            '1': {
              spaceLeftInCol: columnDataLength,
              colData: []
            }
          }
        }
      );
    } else {
      menuColMap = childDetails.reduce(
        (acc, currItem = {}) => {
          let currentItemsNew = [];
          if (currItem && currItem.childDetails && Array.isArray(currItem.childDetails)) {
            currentItemsNew = currItem.childDetails.filter(c_value => {
              if (!c_value.url) {
                return false;
              }
              return true;
            });
          }
          let currColumn = _get(acc, `results[${_get(acc, 'results.length', 1) - 1}]`, 0);
          currColumn = parseInt(currColumn);
          let currEntity = _get(acc, `entities[${currColumn}]`, {});
          let spaceLeftInCol = _get(currEntity, 'spaceLeftInCol', newDesignLuxe ? 15 : 19);
          let spaceNeeded = _get(currentItemsNew, 'length', 0) + 1;
          if (spaceLeftInCol > spaceNeeded) {
            currEntity.spaceLeftInCol = spaceLeftInCol - spaceNeeded;
            currEntity.colData = _get(currEntity, 'colData', []);
            currEntity.colData.push(currItem);
            acc.entities[`${currColumn}`] = currEntity;
          } else {
            currColumn += 1;
            currEntity = _get(acc, `entities[${currColumn}]`, {});
            spaceLeftInCol = _get(currEntity, 'spaceLeftInCol', newDesignLuxe ? 15 : 19);
            spaceNeeded = _get(currentItemsNew, 'length', 0) + 1;
            currEntity.spaceLeftInCol = spaceLeftInCol - spaceNeeded;
            currEntity.colData = _get(currEntity, 'colData', []);
            currEntity.colData.push(currItem);
            acc.entities[`${currColumn}`] = currEntity;
            acc.results.push(`${currColumn}`);
          }
          return acc;
        },
        {
          results: ['1'],
          entities: {
            '1': {
              spaceLeftInCol: newDesignLuxe ? 15 : 19,
              colData: []
            }
          }
        }
      );
    }
    const { results: menuColMapRes = [], entities: menuColMapEntity = {} } = menuColMap;
    const aTagClass = childDetails.length > 0 ? null : 'gold-text';
    const anchorStyle = newDesignLuxe ? { borderBottom: '2px solid black' } : null;
    const content = childDetails.length ? (
      <div className="flyout-inner" >
        <div className="menu-lsec menu-lsec-full-width " id="inner">
          {menuColMapRes.map((columnId, i) => {
            const { colData = [] } = menuColMapEntity[columnId] || {};
            return (
              <div className={`column column-${columnId}`} key={i}>
                {colData.map((data, j) => {
                  let { url = '', name = '' } = data;
                  if (url || name) {
                    return (
                      <MenuSublistSec
                        linkClick={linkClick}
                        data={data}
                        key={j}
                        ABFlagObj={ABFlagObj}
                        makeAbFlagUrl={makeAbFlagUrl}
                      />
                    );
                  }
                })}
              </div>
            );
          })}
        </div>
        {/* {imageDetails && (
          <div className="flyout-slider">
            {imageCaption && <div className="image-caption">{imageCaption}</div>}
            {imageDetails.length > 1 ? (
              <Slider {...slickSettings} ref="slick">
                {imageSlider}
              </Slider>
            ) : (
              <div>{imageSlider}</div>
            )}
          </div>
        )} */}
      </div>
    ) : null;

    if (isBrands && newDesignLuxe) {
      return (
        <li>
          <LuxeBrandList
            values={childDetails}
            menuColMap={menuColMap}
            mouseEnter={this.mouseEnter}
            mouseExit={this.mouseEnter}
            linkClick={linkClick}
            showDirectory={isNewBrandDirectoryDesktop}
          />
        </li>
      );
    }

    return (
      <li
      id='listItems-shopBy'
        className={`catg ${activeLink}`}
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseExit}
        onFocus={this.mouseEnter}
        onBlur={this.mouseExit}
      >
        <div 
          role='tab'
          aria-label={`${name} acts as link`}
          aria-selected={this.state.active}
          id={`tab-${name}`}
          aria-controls={`tabpanel-${name}`}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              const a = e.currentTarget.querySelector('a[href]');
              if (a) a.click();
            }
          }
          }
        >
        <a
        tabIndex={-1}
          href={makeAbFlagUrl(makeValidUrl(url))}
          onClick={() => {
            linkClick(url, name);
          }}
          className={aTagClass}
          style={anchorStyle}
          data-test="navigation-list"
          id="shop-by-tabs"
        >
          {name}
        </a>
        {getNavTag({ tag, pathname, url })}
        </div>
        {content}
      </li>
    );
  }
}

export default MenuSublistFirst;
